import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const topicApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/topics/`,
      {params: params})
  },
  detail (topicId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/topics/${topicId}/`,
      {params: params})
  },
  create (params) {
    // 创建新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/topics/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/topics/`, querystring.stringify(params))
  },
  update (topicId, params) {
    // 更新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/topics/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/topics/${topicId}/`, querystring.stringify(params))
  },
  delete (topicId) {
    window.console.log("发起删除请求")
    return axios.delete(
      `${ApiSetting.baseUrl}/api/topics/${topicId}/`
    )
  }
}

export default topicApi
